module.exports = __webpack_public_path__ + "static/media/learning-react.9bfabd2a.md";